import { render, staticRenderFns } from "./testShare.vue?vue&type=template&id=496ecef8&scoped=true"
import script from "./testShare.vue?vue&type=script&lang=js"
export * from "./testShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496ecef8",
  null
  
)

export default component.exports